import React, { useEffect } from 'react';

// Import the images for each artboard
// Adjust these paths to match your project structure
import artboard1Image from '../assets/BySex-Artboard_1.png';
import artboard2Image from '../assets/BySex-Artboard_2.png';
import artboard3Image from '../assets/BySex-Artboard_3.png';

/**
 * BySexChart Component
 * 
 * A responsive visualization showing median age by sex with
 * three different layouts for various screen sizes.
 */
const BySex = () => {
  useEffect(() => {
    // Handle the ai2html resize function if it exists
    if (window.ResizeAi2html && typeof window.ResizeAi2html === 'function') {
      window.ResizeAi2html();
      
      // Add resize listener
      window.addEventListener('resize', window.ResizeAi2html);
      
      // Cleanup on unmount
      return () => {
        window.removeEventListener('resize', window.ResizeAi2html);
      };
    }
  }, []);

  // This is the ai2html output with image sources replaced
  const htmlContent = `
  <!-- Generated by ai2html v0.117.6 - 2025-02-26 14:38 -->
  <!-- ai file: BySex.ai -->
  <style media="screen,print">
    #g-BySex-box ,
    #g-BySex-box .g-artboard {
      margin:0 auto;
    }
    #g-BySex-box p {
      margin:0;
    }
    #g-BySex-box .g-aiAbs {
      position:absolute;
    }
    #g-BySex-box .g-aiImg {
      position:absolute;
      top:0;
      display:block;
      width:100% !important;
    }
    #g-BySex-box .g-aiSymbol {
      position: absolute;
      box-sizing: border-box;
    }
    #g-BySex-box .g-aiPointText p { white-space: nowrap; }
    #g-BySex-Artboard_1 {
      position:relative;
      overflow:hidden;
    }
    #g-BySex-Artboard_1 p {
      font-weight:700;
      line-height:17px;
      opacity:1;
      letter-spacing:0em;
      font-size:14px;
      text-align:left;
      color:rgb(33,37,41);
      text-transform:none;
      padding-bottom:0;
      padding-top:0;
      mix-blend-mode:normal;
      font-style:normal;
      height:auto;
      position:static;
    }
    #g-BySex-Artboard_1 .g-pstyle0 {
      font-weight:300;
      line-height:14px;
      height:14px;
      font-size:12px;
      text-align:center;
    }
    #g-BySex-Artboard_1 .g-pstyle1 {
      font-weight:300;
      line-height:14px;
      height:14px;
      font-size:12px;
    }
    #g-BySex-Artboard_2 {
      position:relative;
      overflow:hidden;
    }
    #g-BySex-Artboard_2 p {
      font-weight:300;
      line-height:14px;
      height:auto;
      opacity:1;
      letter-spacing:0em;
      font-size:12px;
      text-align:left;
      color:rgb(33,37,41);
      text-transform:none;
      padding-bottom:0;
      padding-top:0;
      mix-blend-mode:normal;
      font-style:normal;
      position:static;
    }
    #g-BySex-Artboard_2 .g-pstyle0 {
      height:14px;
    }
    #g-BySex-Artboard_3 {
      position:relative;
      overflow:hidden;
    }
    #g-BySex-Artboard_3 p {
      font-weight:300;
      line-height:17px;
      height:auto;
      opacity:1;
      letter-spacing:0em;
      font-size:14px;
      text-align:left;
      color:rgb(33,37,41);
      text-transform:none;
      padding-bottom:0;
      padding-top:0;
      mix-blend-mode:normal;
      font-style:normal;
      position:static;
    }
    #g-BySex-Artboard_3 .g-pstyle0 {
      height:17px;
    }
    #g-BySex-Artboard_3 .g-pstyle1 {
      line-height:16px;
      height:16px;
      font-size:13px;
      text-align:center;
    }
    
    /* Add media queries to control which artboard shows at different screen sizes */
    @media (min-width: 930px) {
      #g-BySex-Artboard_2, #g-BySex-Artboard_3 {
        display: none;
      }
    }
    
    @media (min-width: 560px) and (max-width: 929px) {
      #g-BySex-Artboard_1, #g-BySex-Artboard_3 {
        display: none;
      }
    }
    
    @media (max-width: 559px) {
      #g-BySex-Artboard_1, #g-BySex-Artboard_2 {
        display: none;
      }
    }
  </style>

  <div id="g-BySex-box" class="ai2html">

    <!-- Artboard: Artboard_1 -->
    <div id="g-BySex-Artboard_1" class="g-artboard" style="width:930px; height:275.158057902005px;" data-aspect-ratio="3.38" data-min-width="930">
      <div style=""></div>
      <img id="g-BySex-Artboard_1-img" class="g-BySex-Artboard_1-img g-aiImg" alt="" src="${artboard1Image}"/>
      <div id="g-ai0-1" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:3.91%;margin-top:-7.8px;left:54.9865%;margin-left:-41.5px;width:83px;">
        <p class="g-pstyle0">Median age</p>
      </div>
      <div id="g-ai0-2" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.3615%;margin-top:-7.8px;left:0.4263%;width:86px;">
        <p class="g-pstyle1">25 years old</p>
      </div>
      <div id="g-ai0-3" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.3615%;margin-top:-7.8px;left:18.344%;width:35px;">
        <p class="g-pstyle1">35</p>
      </div>
      <div id="g-ai0-4" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.3615%;margin-top:-7.8px;left:36.2549%;width:35px;">
        <p class="g-pstyle1">45</p>
      </div>
      <div id="g-ai0-5" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.3615%;margin-top:-7.8px;left:54.1725%;width:35px;">
        <p class="g-pstyle1">55</p>
      </div>
      <div id="g-ai0-6" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.3615%;margin-top:-7.8px;left:72.0902%;width:35px;">
        <p class="g-pstyle1">65</p>
      </div>
      <div id="g-ai0-7" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.3615%;margin-top:-7.8px;left:90.0012%;width:35px;">
        <p class="g-pstyle1">75</p>
      </div>
      <div id="g-ai0-8" class="g-Layer_1 g-aiAbs" style="top:18.5348%;left:21.3783%;width:13.6559%;">
        <p>Female candidates</p>
      </div>
      <div id="g-ai0-9" class="g-Layer_1 g-aiAbs" style="top:61.4192%;left:21.3783%;width:13.6559%;">
        <p>Male candidates</p>
      </div>
    </div>

    <!-- Artboard: Artboard_2 -->
    <div id="g-BySex-Artboard_2" class="g-artboard" style="width:560px; height:305.86752795336px;" data-aspect-ratio="1.831" data-min-width="560" data-max-width="929">
      <div style=""></div>
      <img id="g-BySex-Artboard_2-img" class="g-BySex-Artboard_2-img g-aiImg" alt="" src="${artboard2Image}"/>
      <div id="g-ai1-1" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:3.1905%;margin-top:-7.8px;left:23.7345%;width:35px;">
        <p class="g-pstyle0">40</p>
      </div>
      <div id="g-ai1-2" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:3.1905%;margin-top:-7.8px;left:38.0202%;width:35px;">
        <p class="g-pstyle0">50</p>
      </div>
      <div id="g-ai1-3" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:3.1905%;margin-top:-7.8px;left:52.3059%;width:35px;">
        <p class="g-pstyle0">60</p>
      </div>
      <div id="g-ai1-4" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:3.1905%;margin-top:-7.8px;left:66.5916%;width:35px;">
        <p class="g-pstyle0">70</p>
      </div>
      <div id="g-ai1-5" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:3.1905%;margin-top:-7.8px;left:80.8773%;width:35px;">
        <p class="g-pstyle0">80</p>
      </div>
      <div id="g-ai1-6" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:3.1905%;margin-top:-7.8px;left:95.1631%;width:35px;">
        <p class="g-pstyle0">90</p>
      </div>
      <div id="g-ai1-7" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:3.1905%;margin-top:-7.8px;left:5.6646%;width:86px;">
        <p class="g-pstyle0">30 years old</p>
      </div>
    </div>

    <!-- Artboard: Artboard_3 -->
    <div id="g-BySex-Artboard_3" class="g-artboard" style="max-width: 330px;max-height: 1149px" data-aspect-ratio="0.287" data-min-width="0" data-max-width="559">
      <div style="padding: 0 0 348.27% 0;"></div>
      <img id="g-BySex-Artboard_3-img" class="g-BySex-Artboard_3-img g-aiImg" alt="" src="${artboard3Image}"/>
      <div id="g-ai2-1" class="g-Layer_4 g-aiAbs g-aiPointText" style="top:2.8526%;margin-top:-17.8px;left:-0.0001%;width:77px;">
        <p class="g-pstyle0">25</p>
        <p class="g-pstyle0">years old</p>
      </div>
      <div id="g-ai2-2" class="g-Layer_4 g-aiAbs g-aiPointText" style="top:20.1329%;margin-top:-9.4px;left:-0.0001%;width:38px;">
        <p class="g-pstyle0">35</p>
      </div>
      <div id="g-ai2-3" class="g-Layer_4 g-aiAbs g-aiPointText" style="top:37.9699%;margin-top:-9.4px;left:-0.0001%;width:38px;">
        <p class="g-pstyle0">45</p>
      </div>
      <div id="g-ai2-4" class="g-Layer_4 g-aiAbs g-aiPointText" style="top:55.236%;margin-top:-8.8px;left:57.8229%;margin-left:-44px;width:88px;">
        <p class="g-pstyle1">Median age</p>
      </div>
      <div id="g-ai2-5" class="g-Layer_4 g-aiAbs g-aiPointText" style="top:56.1551%;margin-top:-9.4px;left:-0.0001%;width:38px;">
        <p class="g-pstyle0">55</p>
      </div>
      <div id="g-ai2-6" class="g-Layer_4 g-aiAbs g-aiPointText" style="top:74.2532%;margin-top:-9.4px;left:0%;width:38px;">
        <p class="g-pstyle0">65</p>
      </div>
      <div id="g-ai2-7" class="g-Layer_4 g-aiAbs g-aiPointText" style="top:92.3513%;margin-top:-9.4px;left:0%;width:38px;">
        <p class="g-pstyle0">75</p>
      </div>
    </div>

  </div>
  `;

  return (
    <div 
      className="bysex-chart-container"
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
};

export default BySex;